import Lenis from 'lenis';

const initBackToTop = ({lenis}: {lenis: Lenis}) => {
    const $els = document.querySelectorAll<HTMLElement>('.js_backToTop');
    if(!$els) return;
    $els.forEach(el => {
      el.addEventListener('click', () => {
        lenis.scrollTo(0);
      });
    });
};

export default initBackToTop;